<template>
	<div class="lang-switcher">
		<button :class="['lang-btn', current === 'en' ? 'active' : '']" @click="switchTo('en')">EN</button>
		<button :class="['lang-btn', current === 'tr' ? 'active' : '']" @click="switchTo('tr')">TR</button>
	</div>
</template>

<script setup>
import { getI18n } from '@/utils/i18nAccessor';
import { computed } from 'vue';

const i18n = getI18n();
const current = computed(() => i18n?.global?.locale?.value || 'en');

const switchTo = async (lang) => {
	if (i18n && typeof i18n.setLocale === 'function') {
		await i18n.setLocale(lang);
	}
};
</script>

<style scoped>
.lang-switcher {
	position: fixed;
	top: 10px;
	right: 10px;
	display: inline-flex;
	gap: 6px;
	z-index: 1000;
}
.lang-btn {
	background: rgba(15, 23, 42, 0.7);
	color: #e5e7eb;
	border: 1px solid rgba(148, 163, 184, 0.35);
	border-radius: 999px;
	padding: 4px 8px;
	font-size: 12px;
	cursor: pointer;
}
.lang-btn.active {
	background: rgba(139,92,246,0.95);
	border-color: rgba(139,92,246,0.6);
	color: white;
	font-weight: 700;
}
</style>
